(function () {
  'use strict';

  function initScrollSteps(root) {
    if (!root) return;
    var track = root.querySelector('.scroll-steps__track');
    var panels = root.querySelectorAll('.scroll-steps__panel');
    if (!track || !panels.length) return;

    var count = panels.length;
    var currentIndex = 0;
    var inView = false;
    var inputCooldown = false;
    var lastScrollY = window.scrollY || window.pageYOffset;
    var scrollLock = false;

    function getSectionHeight() {
      return root.offsetHeight || window.innerHeight;
    }

    function getSectionTop() {
      var rect = root.getBoundingClientRect();
      return rect.top + (window.scrollY || window.pageYOffset);
    }

    function setStep(index) {
      currentIndex = Math.max(0, Math.min(index, count - 1));
      var h = getSectionHeight();
      track.style.height = count * h + 'px';
      track.style.transform = 'translate3d(0, ' + -currentIndex * h + 'px, 0)';
      root.setAttribute('data-active-step', String(currentIndex));
    }

    function lockScrollToSection() {
      scrollLock = true;
      var sectionTop = getSectionTop();
      window.scrollTo({ top: sectionTop, left: 0, behavior: 'smooth' });
      setTimeout(function () {
        scrollLock = false;
      }, 900);
    }

    function goNextStep() {
      if (currentIndex >= count - 1) return false;
      inputCooldown = true;
      setStep(currentIndex + 1);
      setTimeout(function () { inputCooldown = false; }, 500);
      return true;
    }

    function goPrevStep() {
      if (currentIndex <= 0) return false;
      inputCooldown = true;
      setStep(currentIndex - 1);
      setTimeout(function () { inputCooldown = false; }, 500);
      return true;
    }

    function onWheel(e) {
      if (!inView || inputCooldown) return;
      var delta = e.deltaY;
      if (Math.abs(delta) < 5) return;

      if (delta > 0) {
        if (goNextStep()) {
          e.preventDefault();
          e.stopPropagation();
        }
      } else {
        if (goPrevStep()) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }

    function onKeyDown(e) {
      if (!inView || inputCooldown) return;
      var key = e.key;
      var scrollDown = key === 'ArrowDown' || key === 'PageDown';
      var scrollUp = key === 'ArrowUp' || key === 'PageUp';
      if (!scrollDown && !scrollUp) return;

      if (scrollDown) {
        if (goNextStep()) e.preventDefault();
      } else {
        if (goPrevStep()) e.preventDefault();
      }
    }

    function onScroll() {
      if (scrollLock) {
        lastScrollY = window.scrollY || window.pageYOffset;
        return;
      }
      var scrollY = window.scrollY || window.pageYOffset;
      var rect = root.getBoundingClientRect();
      var sectionTop = rect.top + scrollY;
      var vh = window.innerHeight;
      var sectionMid = sectionTop + root.offsetHeight / 2;
      var viewportMid = scrollY + vh / 2;
      inView = rect.top < vh * 0.75 && rect.bottom > vh * 0.25;

      if (inView && viewportMid >= sectionTop - 20 && viewportMid <= sectionTop + root.offsetHeight + 20) {
        var scrolledDown = scrollY > lastScrollY;
        var scrolledUp = scrollY < lastScrollY;
        var threshold = 18;
        if (scrolledDown && scrollY - lastScrollY > threshold) {
          if (currentIndex < count - 1) {
            setStep(currentIndex + 1);
            lockScrollToSection();
          }
        } else if (scrolledUp && lastScrollY - scrollY > threshold) {
          if (currentIndex > 0) {
            setStep(currentIndex - 1);
            lockScrollToSection();
          }
        }
      }
      lastScrollY = scrollY;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.25 }
    );
    observer.observe(root);

    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('keydown', onKeyDown, { passive: false });
    window.addEventListener('scroll', onScroll, { passive: true });

    function onResize() {
      var h = getSectionHeight();
      track.style.height = count * h + 'px';
      track.style.transform = 'translate3d(0, ' + -currentIndex * h + 'px, 0)';
    }
    window.addEventListener('resize', onResize);

    setStep(0);
  }

  function init() {
    document.querySelectorAll('.scroll-steps-section').forEach(initScrollSteps);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.scroll-steps-section');
    if (section) initScrollSteps(section);
  });
})();
